import {COLORS} from '@/utils/constants';
import {ISubmissionProps} from '../../resources/submission';
import {IConfigSchema,} from '../../resources/config-schema';
import {getIndicators} from './calculations';

interface IConfigSchemaProps {
    submissions: ISubmissionProps[]
}

export const configSchema = ({submissions}: IConfigSchemaProps): IConfigSchema => ({
    title: 'I. TASSO DI RAGGIUNGIMENTO DEI BENEFICIARI ATTESI PER LE ATTIVITA’ DI SOCIALITA’ E ASSISTENZA DOMICILIARE',
    tooltip: '(Indicatore 1.1 e Indicatore 1.2) <br> Il visual mostra il tasso di raggiungimento dei beneficiari delle attività di socialità e assistenza domiciliare attesi per il progetto. Il valore è ottenuto dal rapporto tra il numero di beneficiari effettivamente raggiunti secondo il più recente aggiornamento del numero di “Scheda di Monitoraggio per la rilevazione iniziale del profilo delle persone anziane beneficiarie del progetto” create nella sezione “Beneficiari anziani” e i beneficiari che il progetto prevede di raggiungere (80 anziani accompagnati in attività di sociali e assistenza domiciliare).',
    type: 'column',
    categories: ['Rapporto tra il numero di beneficiari effettivi e il numero di beneficiari previsti'],
    series: [
        {
            color: COLORS.blue,
            name: 'Data',
            data: [getIndicators(submissions)]
        },
    ],
});